import { styled } from "@mui/material";

export const StyledLoading = {
  Loading: styled("div")(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  })),
  Root: styled("div")(({ theme }) => ({
    height: "95vh",
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  })),
  Logo: styled("img")(({ theme }) => ({
    marginBottom: "20px",
  })),
};
